import { createContext, useContext } from 'react'

import type {
  ContentPerilakuKerja,
  KinerjaUtamaDetail,
  KinerjaPraktikPembelajaranDimensi,
  KinerjaPraktikPembelajaranContentIndikator,
  PerilakuKerjaAspek,
  KinerjaRoleType,
} from 'types/kinerja'

export const ContentContext = createContext<{
  contentKinerjaUtama: KinerjaUtamaDetail[]
  contentPerilakuKerja?: ContentPerilakuKerja
  contentPraktikPembelajaran: KinerjaPraktikPembelajaranDimensi[]
  contentPengembanganKompetensi: KinerjaUtamaDetail[]
  contentTugasTambahan: KinerjaUtamaDetail[]
  isRaporExists?: boolean

  getPraktikPembelajaranById?: (
    id: KinerjaPraktikPembelajaranContentIndikator['id']
  ) => KinerjaPraktikPembelajaranContentIndikator
  getPengembanganKompetensiById?: (
    id: KinerjaUtamaDetail['id']
  ) => KinerjaUtamaDetail
  getKinerjaUtamaById?: (id: KinerjaUtamaDetail['id']) => KinerjaUtamaDetail
  getTugasTambahanById?: (id: KinerjaUtamaDetail['id']) => KinerjaUtamaDetail
  getAspekPerilakuKerjaById?: (
    id: PerilakuKerjaAspek['id']
  ) => PerilakuKerjaAspek

  role?: KinerjaRoleType
}>({
  contentKinerjaUtama: [],
  contentPraktikPembelajaran: [],
  contentPengembanganKompetensi: [],
  contentTugasTambahan: [],
  isRaporExists: false,
})

export default function useContentContext() {
  return useContext(ContentContext)
}
